import { render } from "./LabelManager.vue?vue&type=template&id=36f7b090&scoped=true"
import script from "./LabelManager.vue?vue&type=script&lang=js"
export * from "./LabelManager.vue?vue&type=script&lang=js"

import "./LabelManager.vue?vue&type=style&index=0&id=36f7b090&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f7b090"]])

export default __exports__